<template>
<div class="z-main">
    <header class="z-header" style="border-bottom:0px;box-shadow: 0 1px 5px #515151;">
        <div></div>
        <div>{{$t('交易记录')}}</div>
        <div></div>
    </header>
    <div class="z-body" :style="{height:(windowHeight-100)+'px'}">
        <div class="z-body-in">
        <!-- 查询 -->
        <div class="z-form-search">
            <div>
                <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="-20"
                    :nudge-top="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                >
                    <v-text-field dark
                        style="margin: 0px;color: #fff;"
                        slot="activator"
                        v-model="dateFormatted"
                        persistent-hint
                        prepend-icon="event">
                    </v-text-field>
                    <v-date-picker dark
                        v-model="date"
                        no-title
                        @input="menu = false">
                    </v-date-picker>
                </v-menu>
            </div>
            <div>
                &nbsp;{{$t('至')}}&nbsp;
            </div>
            <div>
                <v-menu
                    ref="menu2"
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="-20"
                    :nudge-top="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                >
                    <v-text-field dark
                        style="margin: 0px;"
                        slot="activator"
                        v-model="dateFormatted2"
                        persistent-hint
                        prepend-icon="event" >
                    </v-text-field>
                    <v-date-picker dark
                        v-model="date2"
                        no-title
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </div>
            <div>
                <div v-on:click="search"
                class="z-form-search-btn" style="color:#fff;">{{$t('查询')}}</div>
            </div>
        </div>
        <!-- 数据 -->
        <div style="padding: 10px;width: 100%;overflow:scroll;">
            <!-- <div>成交记录</div> -->
            <div class="recordBox">
                <div>
                    <div style="width: 100px;">{{$t('名称')}}</div>
                    <!-- <div style="width: 100px;">交易账户</div> -->
                    <div style="width: 100px;">{{$t('买卖')}}</div>
                    <div style="width: 100px;">{{$t('开平')}}</div>
                    <div style="width: 100px;">{{$t('成交价')}}</div>
                    <div style="width: 100px;">{{$t('手数')}}</div>
                    <div style="width: 100px;">{{$t('平仓盈亏')}}</div>
                    <div style="width: 100px;">{{$t('成交时间')}}</div>
                    <!-- <div style="width: 100px;">清算时间</div> -->
                    <!-- <div style="width: 100px;">委托编号</div>
                    <div style="width: 100px;">成交编号</div> -->
                </div>
                <div class='totalLine'></div>
                <load-more
                      :bottom-method="loadBottom"
                      :bottom-all-loaded="allLoaded"
                      :bottomPullText='bottomText'
                      :auto-fill="false"
                      @bottom-status-change="handleBottomChange"
                      ref="loadmore">
                      <div class="recordBox">
                        <div v-for="item in contentData" class="z-contentData">
                            <div style="width: 100px;">{{item.product}}</div>
                            <!-- <div style="width: 100px;">{{item.tradeusername}}</div> -->
                            <div style="width: 100px;">{{$t(item.mp)}}</div>
                            <div style="width: 100px;">{{$t(item.kp)}}</div>
                            <div style="width: 100px;">{{item.price}}</div>
                            <div style="width: 100px;">{{item.nums}}</div>
                            <div style="width: 100px;">{{item.profit}}</div>
                            <div style="width: 100px;">{{item.atime}}</div>
                            <!-- <div style="width: 100px;">{{item.ctime}}</div> -->
                            <!-- <div style="width: 100px;">{{item.wt_id}}</div>
                            <div style="width: 100px;">{{item.trade_id}}</div> -->
                        </div>
                        </div>
                </load-more>
            </div>
        </div>
      </div>
    </div>
    <!-- 底部菜单 -->
    <ButtomMenu active="2" />
</div>
</template>

<script>
import ButtomMenu from '../components/ButtomMenu.vue'
import loadMore from "../components/loadMore.vue"
export default {
    name: 'transactionRecord',
    data() {
        return {
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: new Date().toISOString().substr(0, 10),
            menu: false,
            date2: new Date().toISOString().substr(0, 10),
            dateFormatted2: new Date().toISOString().substr(0, 10),
            menu2: false,
          page:1,
          nowPage:1,
          loading: false,
            allLoaded: false,
            bottomText: this.$t('上拉加载更多')+'...',
            bottomStatus: '',

          contentData:[],
          analog:0,
          contentData:[],
          cj:[],
          pc:[],
          cc:[],
          ccHz:[],
          money:"",
          ablemoney:"",
          useRate:"",
          day:"",
          userNo:""
        }
    },
    watch: {
        date (val) {
            this.dateFormatted = this.date
        },
        date2 (val) {
            this.dateFormatted2 = this.date2
        }
    },
    mounted() {
      this.search()
    },
    components:{
        'load-more': loadMore,
        ButtomMenu
    },
    methods: {
        _scroll: function(ev) {
  ev = ev || event;
  this.scrollHeight = this.$refs.innerScroll.scrollHeight;
  this.scrollTop = this.$refs.innerScroll.scrollTop;
  this.containerHeight = this.$refs.innerScroll.offsetHeight;
  },
  loadBottom: function() {
  let _this=this;
  this.$store.commit('layer',this.$t('数据加载中'))
  if (this.total == this.contentData.length) {
    // 当allLoaded = true时上拉加载停止
    this.loading = false;
    this.allLoaded = true;
    setTimeout(function () {
    _this.$store.commit('layer',_this.$t('暂无数据'))
    },1000)
  }else {
    this.post('api/Trade/Records.html', {
      stime:this.date,
      etime:this.date2,
    page:this.nowPage+1
    }).then((res) => {
    setTimeout(function () {
      if(res.code==0){
        _this.total = res.data.total
      _this.nowPage=res.data.page
      for(let i=0;i<res.data.lists.length;i++){
        _this.contentData.push(res.data.lists[i])
      }
      _this.$store.commit('layer',this.$t('加载完成'))
      }else {
      _this.$store.commit('layer',this.$t('加载失败'))
      }
    },1000)
    })
  }
  },
  handleBottomChange(status) {
    this.bottomStatus = status;
  },
      search:function () {
        let _this=  this;
        this.get('api/Trade/Records.html', {
          stime:this.date,
          etime:this.date2,
          page:1
        }).then((res) => {
          if(res.code==0){
            _this.total = res.data.total
            _this.contentData=res.data.lists
            if (res.data.total==0) {
                _this.$store.commit('layer',_this.$t('暂无数据'))
            }
          }else {
            _this.$store.commit('layer',res.msg)
          }
        })
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .analogBtn{
    width: 20%;
    display: flex;
    text-align: center;
    color: white;
  }
  .analogBtn >div{
    width:50%;
    padding:8px 0px;
    border-radius: 4px;
  }
  .analogActive{
    background-color: orangered;
  }
  .recordTransaction{
    display: flex;
  }
  .recordTransaction >div{
    padding: 10px 20px 10px 0px;
    border-top:1px dashed gray;
    border-bottom:1px dashed gray;
  }
  .recordTransaction >div >div{
    display: flex;
    justify-content: space-between;
    width: 200px;
  }
  .recordBox{
    width: 700px;
  }
  .recordBox >div{
    display: flex;
  }
  .totalLine{
    display: flex;
    border-bottom: 1px dashed gray;
    padding-bottom: 10px
  }
  .z-contentData {
    width: 100%;
  }
  .z-contentData div{
    float: left;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/sort.vue